import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';
import {CoreDI, SlotEventAdapter} from '@gongxigames/framework/core';
import {slotStore} from '@gongxigames/framework//slotV2/globals';

export class InitSlotEventAdapterAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        const slotEventAdapter = this.installer.getComponent<SlotEventAdapter>(CoreDI.SlotEventAdapter);

        slotEventAdapter.canEmit = !slotStore.slot_isGameStateMachineActive.value;
    }

    getName(): string {
        return 'InitSlotEventAdapterAct';
    }
}